import { getAllMobilePushOperations } from 'admin/actions/mobile-push-operations';
import Table from 'admin/components/atoms/Table';
import Button from 'admin/components/shared/Button';
import Pager from 'admin/components/shared/Pager';
import { COLOR } from 'admin/constants/styles';
import MobilePushOperation from 'admin/models/mobile-push-operation';
import { formatDate } from 'admin/utils';
import PropTypes from 'prop-types';
import * as qs from 'qs';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { createBadge } from '../../atoms/Badge';
import BreadCrumb from '../../molecules/BreadCrumb';

const PageWrapper = styled.div``;

const Header = styled.div`
  display: flex;
  margin-right: 50px;
  direction: column;
`;

const Headline = styled.div`
  margin: 10px auto;
  font-weight: bold;
  font-size: large;
  flex: auto;
`;

const ApproveButton = styled(Button)`
  margin-right: 5px;
`;

const RejectButton = styled(Button)`
  margin-right: 5px;
  background-color: white;
  color: red;
  border: 1px solid #d1d5da;
`;

const AlertMessage = styled.div`
  padding: 15px;
  margin-bottom: 5px;
  background: ${COLOR.success};
  border-radius: 4px;
`;

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: 'サービス管理', href: '', isCurrentPage: true },
  {
    value: '全組織プッシュメッセージ',
    href: '',
    isCurrentPage: true,
  },
];

const HEADERS = [
  { label: '状態', size: 1.5, align: 'left', styles: { maxWidth: '100px' } },
  { label: 'マネー名 (組織)', size: 2, align: 'left', styles: { maxWidth: '160px' } },
  { label: '件名', size: 4, align: 'left' },
  { label: '配信希望日時', size: 1.5, align: 'left', styles: { maxWidth: '160px' } },
  { label: '完了日時', size: 1.5, align: 'left', styles: { maxWidth: '160px' } },
  { label: '作成者', size: 1.5, align: 'left', styles: { maxWidth: '200px' } },
];

const MobilePushOperationStatusBadge = createBadge({
  draft: { label: '下書き', bgColor: '#585f63' },
  submitted: { label: '申請済み', bgColor: '#3c86c9' },
  preprocessing: { label: '準備中', bgColor: '#3c86c9' },
  pending: { label: '承認待ち', bgColor: '#3c86c9' },
  approved: { label: '実行待ち', bgColor: '#3c86c9' },
  rejected: { label: '却下', bgColor: '#343a40' },
  processing: { label: '実行中', bgColor: '#c89600' },
  successed: { label: '完了', bgColor: '#208637' },
  error: { label: 'エラー', bgColor: '#a51d2a' },
  canceled: { label: 'キャンセル済み', bgColor: '#585f63' },
});

const AllMobilePushOperations = ({ location, getAllMobilePushOperations }) => {
  const [operations, setOperations] = useState([]);
  const [pagination, setPagination] = useState();
  const query = qs.parse(location.search.substr(1));
  const [page, setPage] = useState(query.page || 1);
  const [alertMessage, setAlertMessage] = useState();

  const completedOperation = location?.state?.completedOperation;

  useEffect(() => {
    getAllMobilePushOperations(`page=${page}`).then((json) => {
      setOperations(json.rows);
      setPagination(json.pagination);
    });
  }, [page]);

  useEffect(() => {
    if (completedOperation) {
      if (completedOperation === 'approval') {
        setAlertMessage('プッシュメッセージの配信を承認しました');
      } else if (completedOperation === 'rejection') {
        setAlertMessage('プッシュメッセージの配信を却下しました');
      }
      setTimeout(() => {
        setAlertMessage(undefined);
        window.history.replaceState(null, '');
      }, 4000);
    }
  }, [completedOperation]);

  return (
    <PageWrapper>
      <BreadCrumb crumbs={CRUMBS} />

      {alertMessage && <AlertMessage>{alertMessage}</AlertMessage>}

      <Header>
        <Headline>全組織プッシュメッセージ</Headline>
      </Header>
      <Table>
        <Table.Header>
          <Table.Row>
            {HEADERS.map((h) => (
              <Table.Cell size={h.size} key={h.label} align={h.align} styles={h?.styles}>
                {h.label}
              </Table.Cell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {(operations || []).map((r) => {
            const operation = Object.assign(new MobilePushOperation(), r);
            return (
              <Table.Row
                key={`operation_row_${operation.id}`}
                styles={{ background: operation.status === 'canceled' ? '#ddd' : 'unset' }}
              >
                <Table.Cell wordBreak="keep-all">
                  <MobilePushOperationStatusBadge status={operation.status} />
                </Table.Cell>
                <Table.Cell wordBreak="break-word">
                  {operation.private_money.name}
                  <br />({operation.private_money.organization.name})
                </Table.Cell>
                <Table.Cell>
                  <Link to={operation.getDetailURL()}>{operation.subject}</Link>
                </Table.Cell>
                <Table.Cell>{formatDate(operation.scheduled_at) || '-'}</Table.Cell>
                <Table.Cell>{formatDate(operation.done_at) || '-'}</Table.Cell>
                <Table.Cell wordBreak="break-word">{operation.operator?.name ?? ''}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
        <Table.Footer>
          <Table.Row noBorder>
            <Table.Cell colSpan="8" align="center" styles={{ paddingTop: '16px' }}>
              {pagination && <Pager pagination={pagination} onChangePage={setPage} />}
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </PageWrapper>
  );
};

AllMobilePushOperations.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllMobilePushOperations,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AllMobilePushOperations);
